import {
  Box,
  Button,
  Checkbox,
  Divider,
  Flex,
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Radio,
  RadioGroup,
  Slider,
  SliderFilledTrack,
  SliderMark,
  SliderThumb,
  SliderTrack,
  Text,
  useMediaQuery,
} from "@chakra-ui/react";

import _ from "lodash";
import { FC, ReactNode, useEffect, useMemo, useState } from "react";

import { useGetScoresQuery } from "queries/Jobs";

import {
  aiScoresGroup,
  datePostedFilter,
  defaultPreferenceScore,
  distances,
  preferenceScoreGroup,
  SlideMarkValues,
} from "config/Consts";
import { sortObject } from "utils/jobs";
import { FiltersIcon } from "../atoms/HJSIcons";

import SortByMobile from "../atoms/MobileFilters/SortByMobile";
import { useGetUserProfileQuery } from "queries";
import { useRecoilState } from "recoil";
import {
  jobPayloadState,
  savedJobPayloadState,
  defaultJobPayload,
  defaultSavedJobPayload,
} from "_state/atoms/AppAtoms";
import { useLocation } from "react-router-dom";

const SliderMarkProps = Object.freeze({
  fontSize: [16, 16, 16, 20],
  // fontWeight: "700",
  // color: "white",
  // mb: -3,
  // ml: 8,
});

interface ISectionWithTitle {
  title: string;
  children: ReactNode;
  dividerStyle?: { [key: string]: string | number };
}
const SectionWithTitle: FC<ISectionWithTitle> = ({
  title,
  children,
  dividerStyle = {
    my: 4,
  },
}) => {
  return (
    <Box>
      <Text fontWeight={600}>{title}</Text>
      {children}
      <Divider borderColor="#2C7A7B" sx={{ ...dividerStyle }} />
    </Box>
  );
};

const MobileFilters: FC = () => {
  const location = useLocation();
  const isJobSearch = location.pathname === "/jobs/search";
  // const [reset, setReset] = useState(false);

  const [openModal, setOpenModal] = useState<boolean>(false);
  const [openSortByModal, setSortByModal] = useState<boolean>(false);
  const [selectedAiScores, setSelectedAiScores] = useState<string[]>([]);
  const [checked, setChecked] = useState<boolean[]>([]);

  const [payload, setPayload] = useRecoilState(jobPayloadState);
  const [savedJobPayload, setSavedJobPayload] =
    useRecoilState(savedJobPayloadState);

  const getDefaultPayload = isJobSearch
    ? defaultJobPayload
    : defaultSavedJobPayload;
  const getPayload = isJobSearch ? payload : savedJobPayload;
  const updatePayload = isJobSearch ? setPayload : setSavedJobPayload;

  const [preferenceScore, setPreferenceScore] = useState<number>();
  const [postedDate, setPostedDate] = useState<number>();
  const [locationVal, setLocationVal] = useState<number>();
  // const [postedDate, setPostedDate] = useState<string>(
  //   datePostedFilter[1].toString()
  // );

  const { data: scores }: any = useGetScoresQuery();

  const sortedObject = useMemo(() => {
    return sortObject(scores?.aiScore ?? {});
  }, [scores]);

  const [isLargerThan600] = useMediaQuery("(min-width:600px)");
  const { data: userDetails } = useGetUserProfileQuery();

  const handleDone = (): void => {
    const payload: any = {};
    aiScoresGroup.includes(userDetails?.group) &&
      (payload.aiScore = selectedAiScores);
    preferenceScoreGroup.includes(userDetails?.group) &&
      (payload.preferenceScore = preferenceScore);

    updatePayload((prev: any) => ({
      ...prev,
      ...payload,
      postedDate: postedDate,
      distance: locationVal,
    }));
    setOpenModal(false);
  };

  // console.log(
  //   "pref : ",
  //   preferenceScore,
  //   "posted : ",
  //   postedDate,
  //   "location : ",
  //   locationVal
  // );

  const handleReset = (): void => {
    setSelectedAiScores([]);
    setChecked([]);
    setPreferenceScore(defaultPreferenceScore);
    setPostedDate(getDefaultPayload.postedDate);
    setLocationVal(getDefaultPayload.distance);
    updatePayload(getDefaultPayload);
  };

  // const handleReset = (): void => {};

  useEffect(() => {
    if (openModal) {
      console.log("use");
      setSelectedAiScores(getPayload?.aiScore ?? []);
      setPreferenceScore(getPayload.preferenceScore);
      setPostedDate(getPayload.postedDate);
      setLocationVal(getPayload.distance);
    }
  }, [openModal]);

  console.log("preference : ", preferenceScore);

  return (
    <>
      <Flex gap={2}>
        <Box
          backgroundColor="teal.600"
          px={6}
          py={2}
          className="flex items-center gap-2 rounded-md justify-center"
          onClick={() => setOpenModal(true)}
          fontSize={14}
        >
          <FiltersIcon />
          <Text color="white">Filters</Text>
        </Box>
        {isJobSearch && <SortByMobile />}
      </Flex>
      <Modal
        isOpen={openModal}
        closeOnOverlayClick={false}
        closeOnEsc={false}
        onClose={() => {
          setOpenModal(false);
        }}
        isCentered={true}
        size={isLargerThan600 ? "md" : "xs"}
      >
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Filters</ModalHeader>
          <Divider borderColor="#2C7A7B" />
          <ModalCloseButton />
          <Box
            p={4}
            sx={{
              "& *": { fontSize: "14px !important" },
              maxH: "70vh",
              overflow: "auto",
            }}
          >
            {aiScoresGroup.includes(userDetails?.group) && (
              <SectionWithTitle title="AI Score">
                <Flex direction="column" gap={4} py={4}>
                  {Object.keys(sortedObject)?.map(
                    (key: string, idx: number) => (
                      <Box
                        key={_.uniqueId("sector")}
                        // backgroundColor="teal.600 !important"

                        _hover={{
                          backgroundColor: "hjsSecondaryHover !important",
                        }}
                        // _focus={{ backgroundColor: "hjsSecondaryHover" }}
                        onClick={() => {
                          if (!checked[idx]) {
                            setSelectedAiScores((prev: any) => [...prev, key]);
                            setChecked((prev: any) => {
                              prev[idx] = true;
                              return [...prev];
                            });
                          } else {
                            setSelectedAiScores((prev: string[]) => {
                              let foundIdx = -1;
                              for (let i = 0; i < prev?.length; i++) {
                                if (prev[i] === key) {
                                  foundIdx = i;
                                  break;
                                }
                              }
                              foundIdx >= 0 && prev.splice(foundIdx, 1);
                              return [...prev];
                            });
                            setChecked((prev) => {
                              prev[idx] = false;
                              return [...prev];
                            });
                          }
                        }}
                      >
                        {/* <MenuItemOption /> */}
                        <Checkbox
                          className="ai-checkbox"
                          //   colorScheme="white"
                          isChecked={checked[idx]}
                        >
                          <Text
                            fontSize={{ base: 14, md: 16 }}
                            fontWeight="600"
                            // color="white"
                          >
                            {`${scores?.aiScore?.[key] as string} - ${
                              key === "Healthcare"
                                ? "Orderly/Personal Care"
                                : key
                            }`}
                          </Text>
                        </Checkbox>
                      </Box>
                    )
                  )}
                </Flex>
              </SectionWithTitle>
            )}
            {preferenceScoreGroup.includes(userDetails?.group) && (
              <SectionWithTitle title="Preference">
                <Box py={4}>
                  <Slider
                    aria-label="slider-ex-2"
                    colorScheme="#2C7A7B"
                    // defaultValue={preferenceScore ?? defaultPreferenceScore}
                    min={1}
                    max={99}
                    value={preferenceScore}
                    onChange={(val) => {
                      setPreferenceScore(val);
                    }}
                  >
                    {SlideMarkValues.map((value, idx) => (
                      <SliderMark
                        key={_.uniqueId("slider_mark_")}
                        value={value}
                        // {...SliderMarkProps}
                        ml={idx > 0 ? -4 : "initial"}
                        my={3}
                        // ml={-2}
                      >
                        {value}
                      </SliderMark>
                    ))}
                    <SliderTrack bg="hjsSliderTrack">
                      <SliderFilledTrack />
                    </SliderTrack>
                    <SliderThumb bg="primaryThemeColor" />
                  </Slider>
                </Box>
                <Text fontSize="1rem">
                  Show jobs scored {preferenceScore} or above
                </Text>
              </SectionWithTitle>
            )}

            <SectionWithTitle title="Posted date">
              <RadioGroup
                fontSize={{ base: 14, md: 16 }}
                mt={4}
                value={postedDate?.toString()}
                onChange={(val: string) => setPostedDate(Number(val))}
                className="flex flex-col gap-4"
              >
                {Object.values(datePostedFilter).map((value) => (
                  <Radio key={value} value={`${value}`}>
                    {value} days ago
                  </Radio>
                ))}
              </RadioGroup>
            </SectionWithTitle>
            <SectionWithTitle title="Location">
              <RadioGroup
                display="grid"
                gridTemplateColumns="repeat(2,1fr)"
                gap={4}
                mt={4}
                value={locationVal?.toString()}
                onChange={(val: string) => setLocationVal(Number(val))}
              >
                {distances.map((distance, idx) => {
                  const value = Number(distance.split(" ")[0]);
                  return (
                    <Box
                      width="fit-content"
                      key={_.uniqueId("distance-filter")}
                    >
                      <Radio value={`${value}`}>{distance}</Radio>
                    </Box>
                  );
                })}
              </RadioGroup>
            </SectionWithTitle>
          </Box>

          <ModalFooter>
            <Button
              bg="rgba(0, 0, 0, 0.08)"
              color="teal.600"
              mr={3}
              px={6}
              py={2}
              fontSize={14}
              onClick={handleReset}
            >
              Reset
            </Button>
            <Button
              bg="teal.600"
              px={6}
              py={2}
              color="white"
              fontSize={14}
              onClick={handleDone}
            >
              Done
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default MobileFilters;
